const BASE_URL = "https://core.teadrop.us/"

export {BASE_URL}